import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	actionButtonNonFinal: {
		id: 'periscope.suggestions.pull-request-needs-work.action-button-non-final',
		defaultMessage: 'View changes',
		description:
			'This is the text on the button that will redirect the user to their pull request.',
	},
});
